import axios from 'axios';
import FirebaseService from '../services/FirebaseService'
axios.defaults.baseURL = process.env.REACT_APP_REST_URL
axios.defaults.headers.common = {'Authorization': `Bearer ${localStorage.getItem('fb_auth_token')}`}
export default axios;